"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGa = _interopRequireDefault(require("react-ga"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var OutboundLink = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OutboundLink, _React$Component);

  function OutboundLink(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, OutboundLink);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(OutboundLink).call(this, props));
    _this.sendOutboundLinkEvent = _this.sendOutboundLinkEvent.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(OutboundLink, [{
    key: "getExtraneousProps",
    value: function getExtraneousProps() {
      var _this$props = this.props,
          to = _this$props.to,
          label = _this$props.label,
          eventLabel = _this$props.eventLabel,
          as = _this$props.as,
          newTab = _this$props.newTab,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["to", "label", "eventLabel", "as", "newTab"]);
      return rest;
    }
  }, {
    key: "createContainerProps",
    value: function createContainerProps() {
      var _this$props2 = this.props,
          to = _this$props2.to,
          newTab = _this$props2.newTab,
          rest = (0, _objectWithoutProperties2["default"])(_this$props2, ["to", "newTab"]);
      var linkProps = newTab ? {
        href: to,
        target: '_blank'
      } : {
        href: to
      };
      return _objectSpread({}, linkProps, {}, rest, {
        onClick: this.sendOutboundLinkEvent
      });
    }
  }, {
    key: "sendOutboundLinkEvent",
    value: function sendOutboundLinkEvent() {
      var _this$props3 = this.props,
          label = _this$props3.label,
          eventLabel = _this$props3.eventLabel;

      _reactGa["default"].outboundLink({
        label: eventLabel || label
      }, function () {
        return null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          label = _this$props4.label,
          as = _this$props4.as,
          children = _this$props4.children;

      var elementProps = _objectSpread({}, this.createContainerProps(), {
        children: label || children
      });

      return _react["default"].createElement(as, elementProps);
    }
  }]);
  return OutboundLink;
}(_react["default"].Component);

exports["default"] = OutboundLink;
OutboundLink.propTypes = {
  to: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  eventLabel: _propTypes["default"].string,
  as: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
  newTab: _propTypes["default"].bool
};
OutboundLink.defaultProps = {
  eventLabel: '',
  as: 'a',
  newTab: true
};